import {
    Component, OnInit, Input, OnDestroy,
    AfterViewInit, ChangeDetectionStrategy,
    ChangeDetectorRef, ViewChild, SimpleChanges, OnChanges
} from '@angular/core';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';

import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import * as fromPaymentFoundationTrustee from '../../../screens/payment-foundation-trustee/state/payment-foundation-trustee.selectors'
import * as PaymentFoundationTrusteeAction from '../../../screens/payment-foundation-trustee/state/payment-foundation-trustee.actions';
import { SelectionModel } from '@angular/cdk/collections';
import { AngularMaterialService, LGEDataService } from '../..';
import { Store } from '@ngrx/store';
import { saveAs } from "file-saver";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'foundation-payment-table',
    templateUrl: 'foundation-payment-table.component.html',
    styleUrls: ['foundation-payment-table.component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FoundationPaymentTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input() tableType: string;
    @Input() data: any[];
    public displayedColumns = ['select', 'requestNo', 'orgInfoName', 'subsection', 'dateApproved', 'paymentOption', 'totalAmount', 'status', 'action'];
    public dataSource: MatTableDataSource<any>;
    datePipe = new DatePipe('en-US');
    localData: any[];
    selection = new SelectionModel<any>(true, []);
    selectedRequests = [];
    isShowVAlidate = false;
    selectedCreditRequests = [];
    selectedPaymentValue = '';
    isAllChecked = false;
    isIndeterminate = false;

    constructor(
        private store: Store<fromPaymentFoundationTrustee.State>,
        private ams: AngularMaterialService,
        private lgeService: LGEDataService,
        private router: Router
    ) {

    }

    public ngOnInit() {
        // this.startSubscriptions();
        switch (this.tableType) {
            case 'pending':
                this.displayedColumns = ['select', 'requestNo', 'orgInfoName', 'subsection', 'dateApproved', 'paymentOption', 'totalAmount', 'status', 'action'];
                break;
            case 'processed':
                this.displayedColumns = ['selectProcessed', 'requestNo', 'orgInfoName', 'subsection', 'dateApproved', 'paymentOption', 'totalAmount', 'status', 'confirm', 'action'];
                break;
        }
        setTimeout(() => {
            this.localData = this.data;
            if (this.data !== undefined) {
                this.localData.filter(i => i.statusDescr !== 'Approved').map(value => {
                    switch (value.statusAdmin) {
                        case 'Negotiable':
                            value.statusAdmin = 'Check Issued'
                            break;
                    }
                });
            }
            this.buildDataSource(this.localData);
            this.clearToggle();
        });
    }
    buildDataSource(data: any) {
        const filter = this.dataSource !== undefined ? this.dataSource.filter : '';
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'subsection': return isNaN(item.orgInfoSubsection) ? item.orgInfoSubsection : +item.orgInfoSubsection;
                case 'dateRequest': return new Date(item.dateRequest);
                case 'dateApproved': return new Date(item.dateApproved);
                default: return item[property];
            }
        };
        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                switch (key) {
                    case 'dateRequest':
                        const newStartDate = this.datePipe.transform(data.dateRequest, 'MM-dd-yyyy');
                        return currentTerm + newStartDate.toString();
                    case 'dateApproved':
                        const newEndDate = this.datePipe.transform(data.dateApproved, 'MM-dd-yyyy');
                        return currentTerm + newEndDate.toString();
                    case 'subsection':
                        return currentTerm + this.getTaxExemptStatus(data.orgInfoSubsection);
                    default:
                        return currentTerm + data[key];
                }
                // return key === 'OrgInfo' ? currentTerm + data.OrgInfo.name : currentTerm + data[key];
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.includes(transformedFilter);
        };
        this.dataSource.filter = filter;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    public ngOnChanges(changes: SimpleChanges) {
        console.log(changes);
        if (changes['data']) {
            setTimeout(() => {
                this.data = changes['data'].currentValue;
                this.localData = this.data;
                if (this.data !== undefined) {
                    if (this.selectedPaymentValue !== '') {
                        this.localData = this.localData.filter(item => item.paymentOption === this.selectedPaymentValue);
                    }
                    this.localData.filter(i => i.statusDescr !== 'Approved').map(value => {
                        switch (value.statusAdmin) {
                            case 'Negotiable':
                                value.statusAdmin = 'Check Issued'
                                break;
                        }
                    });
                }
                this.buildDataSource(this.localData);
                this.clearToggle();
            });
        }
    }

    public getStatusClass(status): string {
        const possibleStatus = ['Approved', 'Sent To Foundation Trustee', 'Paid Credit', 'Check Issued'];
        return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
    }

    public selectRow(row): void {
    }

    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }
    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    onChangePaymentOption(value) {
        this.selectedPaymentValue = value;
        this.localData = JSON.parse(JSON.stringify(this.data));
        if (value !== '') {
            this.localData = this.localData.filter(item => item.paymentOption === value);
        }
        this.buildDataSource(this.localData);
    }

    onView(row) {
        switch (row.requestNo.substring(0, 2)) {
            case 'CC':
                this.router.navigate([`charity-forms/charitable-contribution/${row.requestNo.substring(2)}`]);
                break;
            case 'MG':
                this.router.navigate([`charity-forms/matching-gift/${row.requestNo.substring(2)}`]);
                break;
            case 'CG':
                this.router.navigate([`charity-forms/community-grant/${row.requestNo.substring(2)}`]);
                break;
            case 'PP':
                this.router.navigate([`charity-forms/plant-planet/${row.requestNo.substring(2)}`]);
                break;
            case 'ES':
                this.router.navigate([`charity-forms/event-sponsorship/${row.requestNo.substring(2)}`]);
                break;
            case 'CI':
                this.router.navigate([`charity-forms/community-investment/${row.requestNo.substring(2)}`]);
                break;
            case 'FO':
                this.router.navigate([`charity-forms/foundation/${row.requestNo.substring(2)}`]);
                break;
        }
    }

    onPrint(row) {
        this.lgeService.DownloadFormAsPDF(row.requestNo).subscribe((response) => {
            saveAs(response, `${row.requestNo}.pdf`);

        });
    }

    onUpdateToCheckIssue() {
        // let selectedRequests = this.localData.filter(item => this.selection.selected.includes(item.requestNo))
        //     .map(item => ({
        //         requestNo: item.requestNo,
        //         formName: item.formName,
        //         paymentOption: item.paymentOption,
        //         confirmationNoCC: item.confirmationNoCC
        //     }));
        const localData = JSON.parse(JSON.stringify(this.data));
        this.selectedCreditRequests = localData.filter(request => this.selection.selected.includes(request.requestNo) && request.paymentOption === 'CREDIT' && request.confirmationNoCC === null);
        this.doProcessCreditRequest(0).then(() => {
            const selectedRequests = localData.filter(request => this.selection.selected.includes(request.requestNo) && (request.paymentOption === 'CHECK' ||
                request.paymentOption === 'CREDIT' && request.confirmationNoCC !== null))
                .map(r => ({
                    requestNo: r.requestNo,
                    paymentOption: r.paymentOption,
                    confirmationNoCC: r.confirmationNoCC
                }));
            if (selectedRequests.length > 0) {
                this.ams.showConfirm("Are you sure you want to update selected applications' status to Check Issued/Credit Paid?", '');
                this.ams.confirm.afterClosed().subscribe(result => {
                    if (result === 'yes') {
                        this.store.dispatch(new PaymentFoundationTrusteeAction.UpdateToCheckIssueFoundationTrustee(selectedRequests));
                    } else {
                        this.localData.forEach(r => r.confirmationNoCC = null);
                    }
                });
            }

        });
    }

    isAllSelected(): boolean {
        let isAll = false;
        if (this.data !== undefined) {
            switch (this.tableType) {
                case 'processed':
                    isAll = this.data.filter(r => r.statusAdmin === 'Sent To Foundation Trustee').length === this.selection.selected.length
                    break;
                case 'pending':
                    isAll = this.data.length === this.selection.selected.length
            }
        }
        this.isAllChecked = this.selection.hasValue() && isAll;
        this.isIndeterminate = this.selection.hasValue() && !isAll;
        return this.isAllChecked;
    }

    doProcessCreditRequest(i): Promise<any> {
        return new Promise((resolve) => {
            if (i < this.selectedCreditRequests.length) {
                if (this.selectedCreditRequests.length > 0) {
                    let confirmationData: any = {};
                    confirmationData.formccId = this.selectedCreditRequests[i].requestNo.substring(2);
                    confirmationData.requestNumber = this.selectedCreditRequests[i].requestNo;
                    confirmationData.requestName = this.selectedCreditRequests[i].formName;
                    confirmationData.confirmationNoCC = '';
                    const grant = this.selectedCreditRequests[i].requestNo.substring(0, 2);
                    this.ams.showCreditCardConfirmation('Pay As Foundation Trustee Credit Card', '', confirmationData);
                    this.ams.creditCardConfirmation.afterClosed().subscribe(result => {
                        if (result) {
                            if (result !== 'Skip') {
                                this.selectedCreditRequests[i].confirmationNoCC = result.confirmationNoCC
                            }

                            this.doProcessCreditRequest(i + 1).then(result => {
                                resolve(result);
                            })
                        }
                    });
                }
                // console.log(this.selectedCreditRequests);
            } else {
                resolve('Done');
            }
        });
    }
    public getSelectedRequest() {
        return this.selectedRequests;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle(isChecked) {
        if (this.isAllChecked || this.isIndeterminate && this.localData.length !== this.data.length) {
            this.selection.clear();
        } else {
            switch (this.tableType) {
                case 'processed':
                    const localData = this.dataSource.filteredData.filter(r => r.statusAdmin === 'Sent To Foundation Trustee');
                    localData.forEach(row => this.selection.select(row.requestNo));
                    break;
                case 'pending':
                    this.dataSource.filteredData.forEach(row => this.selection.select(row.requestNo));
                    break;
            }
        }
        this.isAllSelected()
        // console.log(this.isAllSelected());
    }

    formDataChecked(row) {
        this.selection.toggle(row.requestNo);
        this.isAllSelected();
    }

    clearToggle() {
        // this.dataSource.data.forEach(row => {
        //     if (this.selectedRequests.includes(row.formId)) {
        //         this.selection.toggle(row);
        //     }
        // });
        this.selection.clear();
        this.isAllSelected();
    }

    onControlReport(row) {
        const filePath = row !== undefined ? row.filePath : "\\lgeenergy.int\shares\Group1\CCMS_TEST";
        const fileName = filePath.replace(/^.*(\\|\/|\:)/, '');
        this.lgeService.GetControlReportByFilePath(fileName).subscribe((response) => {
            if (response.errorExists) {
                this.ams.closeDialog();
                this.ams.showAlert('Error', response.message);
            } else {
                saveAs(response, fileName);
            }
        });
        // a.href = url;
        // a.download = filePath.substr(filePath.lastIndexOf('/') + 1);
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
    }

    onProcess() {
        const localData = JSON.parse(JSON.stringify(this.data));
        const selectedRequests = localData.filter(request => this.selection.selected.includes(request.requestNo)).map(r => ({
            requestNo: r.requestNo,
            paymentOption: r.paymentOption,
            confirmationNoCC: r.confirmationNoCC
        }));
        if (selectedRequests.length > 0) {
            this.ams.showConfirm('Are you sure you want to process selected application(s)?', '');
            this.ams.confirm.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    this.store.dispatch(new PaymentFoundationTrusteeAction.ProcessPaymentFoundationTrustee(selectedRequests));
                }
            });
        }
    }

    // public payAsCreditCard(row) {
    //     // console.log(row)
    //     let confirmationData: any = {};
    //     const statusId = row.statusId;
    //     confirmationData.formccId = row.formccId == undefined ? row.formId : row.formccId;
    //     confirmationData.requestNumber = row.requestNo;
    //     confirmationData.requestName = row.formName;
    //     confirmationData.confirmationNoCC = '';
    //     const grant = row.requestNo.substring(0, 2);
    //     this.ams.showCreditCardConfirmation('Pay As Credit Card', '', confirmationData);
    //     this.ams.creditCardConfirmation.afterClosed().subscribe(result => {
    //     });

    // }
}
